import type { StrategyNode } from './BaseNode';
import { v4 as uuid } from 'uuid';
import { isStrategyNode } from './typeGuards';
import { reinstantiate } from '../utils/nodeFactory';

export class VarianceNode implements StrategyNode {
    id: string;
    type: 'Variance' = 'Variance';
    title?: string;
    isManualRename?: boolean;
    isTopLevel = true;
    config: {
        target?: StrategyNode;
        parameters: StrategyNode[];
    };

    constructor(
        id: string,
        title?: string,
        target?: StrategyNode,
        parameters: StrategyNode[] = [],
        isManualRename?: boolean
    ) {
        this.id = id;
        this.title = title || 'Variance';
        this.isManualRename = isManualRename;
        this.config = { 
            target: target ? reinstantiate(target) : undefined, 
            parameters: (parameters || []).map(p => reinstantiate(p)) 
        };
    }

    update(id: string, patch: StrategyNode): StrategyNode {
        if (this.id === id) return patch;

        // Recursively update children
        const updatedTarget = this.config.target?.update(id, patch);
        const updatedParams = this.config.parameters.map(p => p.update(id, patch));

        if (updatedTarget !== this.config.target || updatedParams.some((p, i) => p !== this.config.parameters[i])) {
            return new VarianceNode(
                this.id,
                this.title,
                updatedTarget,
                updatedParams,
                this.isManualRename
            );
        }

        return this;
    }

    clone(): StrategyNode {
        return new VarianceNode(
            uuid(),
            this.title,
            isStrategyNode(this.config.target) ? this.config.target.clone() : undefined,
            this.config.parameters.map(p => p.clone()),
            this.isManualRename
        );
    }
}
